import { useEffect, useRef, useState } from "react";
import { CameraIcon, DeleteIcon } from "../../svg";
import uploadFile from "../../../services/uploadFile";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import excelThumbnail from "../../../assets/images/excel-icon.png";
import IconBtn from "../icon-btn";
import { directService } from "../../../services/InspectionOneServices";

function UploadExcelFile({
  formData,
  handleSetFormData,
  isReadOnly,
  isImageLoader,
  setImageLoader = () => {},
  field = null
}: any) {
  const { t } = useTranslation();
  const [selectedFileUrl, setSelectedFileUrl] = useState<string>(formData?.imageUrl);
  const uploadFiles = useRef<HTMLInputElement>(null);

  const getFileExtension = (filename: string): string => {
    return filename.split(".").pop()?.toLowerCase() || "";
  };

  const handleFileInputChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files && event.target.files[0];
    if (file) {
      const extension = getFileExtension(file.name);
      const allowedExtensions = ["xls", "xlsx"];
      if (!allowedExtensions.includes(extension)) {
        alert("Only Excel files (.xls, .xlsx) are allowed.");
        return;
      }

      try {
        setImageLoader(true);
        const { response } = await uploadFile(file, extension, 1);
        const url = response.data.fileUrl;
        if(field)
        {
          let additionalDetails = field.additionalDetails ? JSON.parse(field.additionalDetails): null;
          if(additionalDetails){
            if(additionalDetails.isServiceCall == 1){

              if(additionalDetails.serviceCallDetails){
                try {
                  const requestJson = {
                    excelUrl: url,
                  };
                  const response = await directService.DirectPostServices(additionalDetails.serviceCallDetails.endpoint , requestJson);
                  if (response.success) {
                    handleSetFormData(url, response.data);
                    setImageLoader(false);
                  } else {
                    setImageLoader(false);
                  }
                } catch (error) {
                  setImageLoader(false);
                }
              }
              else{
                handleSetFormData(url)
              }
              
            } 
            else{
              handleSetFormData(url)
            }
          }
          else{
            handleSetFormData(url)
          }
        }
        else{
          handleSetFormData(url)
        }
        
       

        setSelectedFileUrl(url);
        setImageLoader(false);
      } catch (error) {
        console.error("Error uploading file:", error);
        setImageLoader(false);
      }
    } else {
      console.error("No file selected");
    }
  };

  useEffect(() => {
    setSelectedFileUrl(formData?.imageUrl || "");
  }, [formData?.imageUrl]);

  const handleDelete = () => {
    handleSetFormData("")
    setSelectedFileUrl("");
  };

  return (
    <div className="w-full h-auto">
      <p className="text-[1.2rem] font-inter font-normal text-io-gray-66 dark:text-io-black-d1 mb-2">
        {t("Upload Excel File")} {/* Updated for general "file" */}
      </p>

      <div className="w-full h-[19.4rem]">
        {isImageLoader ? (
          <Skeleton width="100%" height={150} borderRadius={3} />
        ) : (
          <>
            <input
              type="file"
              id="uploadExcelFile"
              accept=".xls, .xlsx" // ✅ Accept only Excel files
              onChange={handleFileInputChange}
              ref={uploadFiles}
              className="hidden w-0 h-0"
            />

            {selectedFileUrl ? (
              <div className="w-full h-full relative">
                <div className="w-full h-full rounded-[0.5rem] overflow-hidden border border-io-gray-c8">
                  <img
                    src={excelThumbnail}
                    alt="uploadedExcel"
                    className="w-auto h-full mx-auto object-contain object-center"
                  />
                </div>

                <div className="w-auto absolute bottom-[2%] right-[2%]">
                  <div className="w-auto flex justify-end items-center gap-[1rem]">
                    <div className="w-auto h-auto bg-io-white p-3 rounded-full">
                      <IconBtn
                        icon={<DeleteIcon />}
                        size="small"
                        handleClick={handleDelete}
                      />
                    </div>
                    <div className="w-[3rem]">
                      <label
                        htmlFor="uploadExcelFile"
                        className={`w-full h-auto ${
                          isReadOnly
                            ? "opacity-50 pointer-events-none"
                            : "opacity-100 pointer-events-auto"
                        }`}
                      >
                        <CameraIcon />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <label
                htmlFor="uploadExcelFile"
                className={`w-full h-full block border border-dashed border-io-primary rounded-[0.5rem] ${
                  isReadOnly ? "opacity-50 pointer-events-none" : ""
                }`}
              >
                <div className="w-full h-full flex justify-center items-center">
                  <div className="w-[7.2rem] h-auto mx-auto">
                    <img src={excelThumbnail} alt="uploadExcelThumbnail" />
                  </div>
                </div>
              </label>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default UploadExcelFile;
